module.exports = __webpack_public_path__ + "static/hostel-dc5ac79254d61f0c7e186687c6e3cb44.jpg";